<template>
  <modal
    name="modal--edit-hours"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="300"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    draggable=".drag-handler"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="flex flex-col text-black h-full overflow-hidden w-full bg-white rounded-sm justify-between p-4"
    >
      <div
        class="text-center text-4xl mb-8 font-extralight tracking-tight drag-handler"
      >
        {{ weekDay | capitalize }}
      </div>

      <div class="text-xl">
        <form @submit.prevent="handleConfirm">
          <div
            class="flex flex-row justify-between mb-3"
            v-for="(label, thisIndex) in hours"
            :key="thisIndex"
          >
            <label
              class="w-3/5 justify-start mb-1 pl-2 pr-4 flex items-center"
              :for="label"
            >
              {{ label | capitalize }}
            </label>
            <div class="relative w-2/5">
              <select
                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
                :id="label"
                key="label"
                v-model="localHours[thisIndex]"
                :ref="label"
                :disabled="!isAdmin"
                @click.stop
                @focus.stop="$emit('focused', thisIndex)"
              >
                <option
                  v-for="i in hourNumbers"
                  :key="`${i}-returned`"
                  :value="i"
                  v-text="formatHour(i)"
                />
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="button-set flex flex-row justify-between mt-10">
            <button
              class="buttonOutline focus:shadow-outline focus:outline-none"
              @click.prevent="$modal.hide('modal--edit-hours')"
            >
              Cancel
            </button>

            <button
              v-if="isAdmin"
              class="button focus:shadow-outline focus:outline-none"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { arraysMatch, formatHour } from '@/utils.js'
import { weekdays } from '@/const.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalEditHours',
  data() {
    return {
      weekdays,
      hourNumbers: [...Array(24).keys()].map(x => ++x),
      weekDay: null,
      index: null,
      localHours: []
    }
  },
  computed: {
    ...mapGetters('storeModule', ['hours', 'hoursByDay']),
    ...mapGetters('user', ['isAdmin'])
  },
  methods: {
    ...mapActions('config', ['setFabVisible', 'setDragLock']),
    ...mapActions('storeModule', ['updateItem']),
    formatHour,
    beforeOpen(event) {
      this.weekDay = event.params.id
      this.index = this.weekdays.indexOf(this.weekDay)
      this.localHours = [...this.hoursByDay(this.index)]
      this.setFabVisible(false)
      this.setDragLock(true)
    },
    beforeClose() {
      this.index = null
      this.weekDay = null
      this.localHours = []
      this.setFabVisible(true)
      this.setDragLock(false)
    },
    handleConfirm() {
      if (!arraysMatch(this.hoursByDay(this.index), this.localHours))
        this.updateItem({ [`hours_${this.index}`]: this.localHours })
      this.$modal.hide('modal--edit-hours')
    }
  }
}
</script>
